<div class="simple-layout-main">
  <img src="assets/logo-long.svg" alt="logo" width="150" class="logo">

  <div class="simple-layout-container">
    <router-outlet></router-outlet>
  </div>

  <div class="footer">
    <div>© Energies Demain</div>
    <div>contact&#64;philogi.fr</div>
  </div>
</div>
